/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();
(function () {
  const SEL = ".logo-bar--template--24452089708920__logo_list_XzXnW7 .new-grid.product-grid";
  const intervalMs = 2600;

  function initLogoCarousel() {
    const track = document.querySelector(SEL);
    if (!track) return;

    // sadece mobilde çalışsın
    if (!window.matchMedia("(max-width: 768px)").matches) return;

    // aynı sayfada tekrar init olmasın
    if (track.dataset.autoScrollInit === "1") return;
    track.dataset.autoScrollInit = "1";

    let timer = null;
    let isInteracting = false;

    const items = () => Array.from(track.querySelectorAll(":scope > .grid-item"));

    const currentIndex = () => {
      const it = items();
      if (!it.length) return 0;
      const center = track.scrollLeft + track.clientWidth / 2;
      let idx = 0, best = Infinity;
      for (let i = 0; i < it.length; i++) {
        const el = it[i];
        const c = el.offsetLeft + el.offsetWidth / 2;
        const d = Math.abs(c - center);
        if (d < best) { best = d; idx = i; }
      }
      return idx;
    };

    const goTo = (idx) => {
      const it = items();
      const el = it[idx];
      if (!el) return;
      const left = el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2;
      track.scrollTo({ left, behavior: "smooth" });
    };

    const start = () => {
      stop();
      timer = setInterval(() => {
        if (isInteracting) return;
        const it = items();
        if (!it.length) return;
        goTo((currentIndex() + 1) % it.length);
      }, intervalMs);
    };

    const stop = () => { if (timer) clearInterval(timer); timer = null; };

    const onDown = () => { isInteracting = true; stop(); };
    const onUp = () => { isInteracting = false; start(); };

    track.addEventListener("pointerdown", onDown, { passive: true });
    track.addEventListener("pointerup", onUp, { passive: true });
    track.addEventListener("pointercancel", onUp, { passive: true });
    track.addEventListener("touchstart", onDown, { passive: true });
    track.addEventListener("touchend", onUp, { passive: true });

    // görünürken çalışsın
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => e.isIntersecting ? start() : stop());
    }, { threshold: 0.2 });
    io.observe(track);
  }

  document.addEventListener("page:loaded", initLogoCarousel);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initLogoCarousel);
  } else {
    initLogoCarousel();
  }
})();
